export default {
  app: {
    logo: 'SkyRadar Logo',
    notProvided: 'Not provided',
    contactFormSubject: 'Contact Form: ',
  },
  landing: {
    title: 'SkyRadar',
    subtitle: 'Enterprise-Grade Lightning Detection Solution',
    description: 'SkyRadar offers a comprehensive lightning detection and monitoring platform for businesses and organizations. Our advanced technology provides real-time alerts, detailed analytics, and seamless integration with your existing systems to protect your assets, operations, and personnel from lightning hazards.',
    features: {
      title: 'Key Features',
      subtitle: 'Explore the powerful features that make our platform stand out',
      map: 'Real-time Monitoring',
      mapDescription: 'Track lightning strikes as they happen with our high-precision detection system',
      filter: 'Advanced Analytics',
      filterDescription: 'Gain valuable insights with historical data analysis and customizable reports',
      location: 'Instant Alerts',
      locationDescription: 'Receive immediate notifications when lightning threatens your area of interest',
      theme: 'Seamless Integration',
      themeDescription: 'Connect with your existing systems and workflows for a unified solution',
    },
    ctaButton: 'Download App',
    mobileApp: {
      title: 'SkyRadar Mobile App',
      subtitle: 'Stay protected wherever you go with our powerful mobile application',
      heading: 'Track Lightning Activity and Stay Safe',
      description: 'Our mobile app provides instant notifications about lightning strikes in your area, helping you make timely safety decisions whether you\'re hiking in the mountains, camping, or enjoying outdoor activities in the Balkans.',
      highlight: 'Monitor lightning activity in real-time and receive immediate notifications when strikes are detected near your location.',
      downloadIos: 'Download for iOS',
      downloadAndroid: 'Download for Android',
      comingSoon: 'Coming Soon',
    },
    benefits: {
      title: 'Why Choose SkyRadar',
      reliability: 'Unmatched Reliability',
      reliabilityDescription: '99.9% uptime guarantee with redundant systems for continuous operation',
      accuracy: 'Superior Accuracy',
      accuracyDescription: 'Precise detection technology with minimal false positives',
      scalability: 'Fully Scalable',
      scalabilityDescription: 'From single-site to global enterprise deployment with consistent performance',
      support: 'Dedicated Support',
      supportDescription: '24/7 technical assistance from our team of experts',
    },
    testimonials: {
      title: 'What Our Clients Say',
      client1: {
        quote: 'SkyRadar has transformed how we manage weather-related risks across our facilities. The real-time alerts have helped us prevent several potential incidents.',
        author: 'John Smith',
        position: 'Safety Director, Global Energy Corp'
      },
      client2: {
        quote: 'The integration capabilities are impressive. We connected SkyRadar with our existing security systems in just days, not months.',
        author: 'Maria Rodriguez',
        position: 'CTO, Industrial Solutions Inc.'
      },
      client3: {
        quote: 'The analytics provided by SkyRadar have helped us optimize our maintenance schedules and improve operational efficiency.',
        author: 'David Chen',
        position: 'Operations Manager, National Grid Services'
      }
    },
    pricing: {
      title: 'Flexible Solutions for Every Need',
      description: 'We offer customized packages tailored to your specific requirements and scale.',
      basic: 'Basic',
      basicDescription: 'For small businesses and single-site operations',
      professional: 'Professional',
      professionalDescription: 'For medium-sized businesses with multiple locations',
      enterprise: 'Enterprise',
      enterpriseDescription: 'For large organizations with complex requirements',
      contact: 'Contact us for pricing',
      contactSales: 'Contact Sales',
      mostPopular: 'Most Popular',
    },
    about: {
      title: 'Integration Capabilities',
      description: 'If you want to receive lightning information or integrate with your services, we offer flexible solutions for any needs. Our APIs and integration tools make it easy to connect lightning data to your existing systems.',
      mission: 'We strive to make lightning data accessible to everyone through simple and reliable integrations with any services and platforms.',
    },
    footer: {
      rights: 'All rights reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      quickLinks: 'Quick Links',
      contactUs: 'Contact Us',
      email: 'Email: info@skyradar.com',
    },
    partners: {
      title: 'Our Partners',
      subtitle: 'We\'re proud to collaborate with these organizations to make our mission possible',
      icdsoft: 'ICDSoft',
      icdsoftDescription: 'Main hosting and infrastructure partner',
      firebrigade: 'FireBrigade1',
      firebrigadeDescription: 'Emergency services collaboration partner',
    },
    dataProcessing: {
      title: 'Powerful Data Processing',
      description1: 'Our system processes hundreds of thousands of lightning events daily across the Balkan region, providing real-time data and analytics to help protect communities and natural resources.',
      description2: 'Through advanced algorithms and dedicated infrastructure, we analyze each lightning strike to determine its location, intensity, and potential risk factors, enabling faster response times for emergency services.',
      feature1: 'Real-time processing of 100,000+ daily events',
      feature2: 'Precise geographic mapping of lightning strikes',
      feature3: 'Automated risk assessment and notification system',
    },
    mobileAppFeatures: {
      feature1: 'Real-time lightning strike notifications',
      feature1Description: 'Get alerts when lightning is detected near your location',
      feature2: 'Interactive lightning map with filters',
      feature2Description: 'Visualize lightning activity with customizable filters',
      feature3: 'Customizable alert radius and settings',
      feature3Description: 'Set your preferred notification distance and alert types',
      feature4: 'Weather forecasts with lightning risk assessment',
      feature4Description: 'Plan your activities with lightning risk forecasts',
      feature5: 'Works offline with cached data',
      feature5Description: 'Access recent data even without internet connection',
    },
    sensorInfrastructure: {
      title: 'Custom Sensor Infrastructure',
      description: 'Looking for a tailored solution to collect data from lightning sensors or weather stations? We provide end-to-end infrastructure setup for organizations that need reliable lightning and weather data collection systems.',
      quote: 'From hardware installation to data collection and analysis, our team of experts will design and implement a custom solution that meets your specific requirements.',
      learnMore: 'Learn More',
      page: {
        hero: {
          title: 'Custom Sensor Infrastructure Solutions',
          subtitle: 'Lightning detection and weather monitoring tailored to your needs',
          description: 'Looking for a custom solution to collect data from lightning sensors or weather stations? Our team provides end-to-end infrastructure setup, from hardware installation to data collection and analysis.',
          contactButton: 'Contact Us Now'
        },
        benefits: {
          title: 'Why Choose Our Sensor Infrastructure',
          subtitle: 'We provide comprehensive solutions for organizations that need reliable lightning and weather data collection systems',
          items: {
            lightningDetection: {
              title: 'Advanced Lightning Detection',
              description: 'Our sensors provide precise lightning detection with high accuracy and minimal false positives.'
            },
            weatherMonitoring: {
              title: 'Comprehensive Weather Monitoring',
              description: 'Monitor temperature, humidity, wind speed, precipitation, and more with our integrated weather sensors.'
            },
            integration: {
              title: 'Easy Integration',
              description: 'Our infrastructure easily integrates with your existing systems through standard APIs and protocols.'
            },
            dataCollection: {
              title: 'Reliable Data Collection',
              description: 'Robust data collection and storage solutions ensure your data is always available when you need it.'
            },
            analytics: {
              title: 'Real-time Analytics',
              description: 'Process and analyze sensor data in real-time to make informed decisions quickly.'
            },
            management: {
              title: 'Remote Management',
              description: 'Monitor and manage your sensor network remotely through our intuitive dashboard.'
            }
          }
        },
        process: {
          title: 'Our End-to-End Process',
          subtitle: 'From consultation to implementation and ongoing support',
          steps: {
            step1: {
              title: 'Consultation & Requirements Analysis',
              description: 'We begin by understanding your specific needs, challenges, and goals. Our team of experts will work with you to identify the optimal sensor configuration and infrastructure setup for your use case.'
            },
            step2: {
              title: 'Custom Solution Design',
              description: 'Based on your requirements, we design a tailored solution that includes hardware selection, network architecture, data collection protocols, and integration with your existing systems.'
            },
            step3: {
              title: 'Implementation & Deployment',
              description: 'Our experienced team handles the installation and configuration of all hardware and software components. We ensure proper calibration and testing to guarantee accurate data collection.'
            },
            step4: {
              title: 'Data Integration & Analytics',
              description: 'We set up data processing pipelines, storage solutions, and analytics tools to transform raw sensor data into actionable insights. Custom dashboards and reports provide easy access to your data.'
            },
            step5: {
              title: 'Ongoing Support & Maintenance',
              description: 'Our relationship doesn\'t end with deployment. We provide comprehensive support, regular maintenance, and system updates to ensure your infrastructure continues to perform optimally.'
            }
          }
        },
        useCases: {
          title: 'Industry Applications',
          subtitle: 'Our sensor infrastructure solutions serve diverse industries with specific needs',
          items: {
            energy: {
              title: 'Energy Sector',
              description: 'Protect power generation and distribution infrastructure from lightning strikes and severe weather.'
            },
            aviation: {
              title: 'Aviation',
              description: 'Ensure safe takeoffs and landings with accurate lightning and weather data for airports.'
            },
            agriculture: {
              title: 'Agriculture',
              description: 'Optimize farming operations with precise weather forecasting and lightning warnings.'
            },
            sports: {
              title: 'Sports & Recreation',
              description: 'Keep outdoor events and activities safe with timely weather and lightning alerts.'
            }
          }
        },
        whyUs: {
          title: 'Why Partner With Us',
          items: {
            expertise: {
              title: 'Industry Expertise',
              description: 'Our team has decades of combined experience in meteorology, sensor technology, and data science.'
            },
            trackRecord: {
              title: 'Proven Track Record',
              description: 'We\'ve successfully implemented sensor networks for organizations across multiple industries worldwide.'
            },
            technology: {
              title: 'Cutting-edge Technology',
              description: 'We utilize the latest advancements in sensor technology, IoT, and cloud computing to deliver superior solutions.'
            },
            approach: {
              title: 'Customized Approach',
              description: 'We don\'t believe in one-size-fits-all solutions. Every system we design is tailored to your specific requirements.'
            },
            support: {
              title: 'Ongoing Support',
              description: 'Our dedicated support team ensures your infrastructure continues to operate at peak performance.'
            }
          }
        },
        contact: {
          title: 'Get in Touch',
          subtitle: 'Interested in our sensor infrastructure solutions? Contact us today to discuss your needs.',
          email: 'Email us directly at',
          emailAddress: 'infrastructure@skyradar.com'
        }
      }
    },
    cta: {
      title: 'Ready to protect your assets from lightning hazards?',
      description: 'Contact our team today to learn how SkyRadar can help your organization implement a comprehensive lightning protection strategy.',
      button: 'Contact Us Now',
    },
    companyDescription: 'Enterprise-grade lightning detection and monitoring solutions for businesses and organizations worldwide.',
    thunderBG: {
      title: 'ThunderBG',
      subtitle: 'Volunteer Project for Lightning Data Collection in the Balkans',
      description: 'ThunderBG is a volunteer initiative dedicated to collecting lightning data across the Balkan region. Our mission is to provide real-time lightning information to help firefighting services respond quickly to potential wildfires and assist tourists in staying safe during outdoor activities.',
      viewDemo: 'View Demo',
    },
    getStarted: 'Get Started',
  },
  header: {
    main: 'Main',
    map: 'Map',
    contact: 'Contact',
    sensorInfrastructure: 'Sensor Infrastructure',
    language: 'Language',
    about: 'About',
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Get in touch with our team',
    description: 'We provide comprehensive solutions for sensor data collection, analysis, application development, and integrations. If you have sensors but lack infrastructure, we can help solve this issue.',
    form: {
      name: 'Name',
      email: 'Email',
      company: 'Company',
      message: 'Message',
      subject: 'Subject',
      phone: 'Phone (optional)',
      submit: 'Submit',
      sending: 'Sending your message...',
      success: 'Thank you for your message! We will get back to you soon.',
      error: 'There was an error sending your message. Please try again later.',
      nameRequired: 'Please enter your name',
      emailRequired: 'Please enter your email',
      emailInvalid: 'Please enter a valid email',
      messageRequired: 'Please enter a message',
      subjectRequired: 'Please enter a subject',
      notificationTitle: 'New contact form submission:',
      notificationName: 'Name:',
      notificationEmail: 'Email:',
      notificationCompany: 'Company:',
      notificationPhone: 'Phone:',
      notificationSubject: 'Subject:',
      notificationMessage: 'Message:',
    },
    services: {
      title: 'Our Services',
      dataCollection: 'Data Collection',
      dataAnalysis: 'Data Analysis',
      aiDevelopment: 'AI Development',
      appDevelopment: 'Application Development',
      integrations: 'Custom Integrations',
    },
  },
  map: {
    title: 'Lightning Map',
    legend: 'Map Legend',
    lightning: 'Lightning',
    recent: 'Lightning in the last 5 minutes',
    medium: 'Lightning in the last 30 minutes',
    old: 'Lightning older than 30 minutes',
    helpTitle: 'How to Use the Map',
    helpText1: 'Use the controls on the right to zoom in/out and find your location.',
    helpText2: 'Filter lightning events by time using the filter button.',
    helpText3: 'Click on lightning icons for more details about each strike.',
    filter: 'Filter Lightning Events',
    timeRange: 'Time Range',
    minutes10: 'Last 10 minutes',
    hour1: 'Last hour',
    hours6: 'Last 6 hours',
    hours24: 'Last 24 hours',
    apply: 'Apply',
    loading: 'Loading Map...',
    error: 'Error loading data. Please try again.',
    noData: 'No lightning events found in this area for the selected time range.',
    controls: {
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      myLocation: 'My location',
      info: 'Map information',
      yourLocation: 'Your location'
    },
    filters: {
      last10min: 'Last 10 minutes',
      lastHour: 'Last hour',
      last6hours: 'Last 6 hours',
      last24hours: 'Last 24 hours',
      filter: 'Filter',
      openFilters: 'Open filters',
      filterLightningEvents: 'Filter Lightning Events',
      closeFilters: 'Close filters',
      currentFilter: 'Current Filter',
      none: 'None',
      selectTimeRange: 'Select Time Range',
      cancel: 'Cancel',
      apply: 'Apply'
    }
  },
};
